import { ITenantTree } from '@d-models/other/tenant.model';
import { IDialogUserLevel } from '@d-models/other/user.model';
import { createAction, props } from '@ngrx/store';
export enum UserActionTypes {
  UPDATE_DIALOG_USER = '[USER] Update DIALOG user',
  UPDATE_DIALOG_CURRENT_USER = '[USER] Update current user',
  UPDATE_DIALOG_USER_LEVEL = '[USER] Update user level',
  UPDATE_DIALOG_PROGRAM_OWNER_ID = '[USER] Update program owner id',
  GET_DIALOG_PROGRAM_OWNER_ID = '[USER] Get program owner id',
  UPDATE_DIALOG_TENANTS = '[USER] Update DIALOG tenants',
  UPDATE_CURRENT_TENANT_INFO = '[USER] Update current tenant info',
}

export const updateDialogUser = createAction(
  UserActionTypes.UPDATE_DIALOG_USER,
  props<{ user: any; level: IDialogUserLevel }>(),
);

export const updateDialogCurrentUser = createAction(
  UserActionTypes.UPDATE_DIALOG_CURRENT_USER,
  props<{ user: any }>(),
);

export const updateDialogUserLevel = createAction(
  UserActionTypes.UPDATE_DIALOG_USER_LEVEL,
  props<IDialogUserLevel>(),
);

export const getDialogProgramOwnerId = createAction(
  UserActionTypes.GET_DIALOG_PROGRAM_OWNER_ID,
  props<IDialogUserLevel>(),
);

export const updateDialogProgramOwnerId = createAction(
  UserActionTypes.UPDATE_DIALOG_PROGRAM_OWNER_ID,
  props<any>(),
);

export const updateDialogTenants = createAction(
  UserActionTypes.UPDATE_DIALOG_TENANTS,
  props<{ tenants: ITenantTree[] }>(),
);

export const updateCurrentTenantInfo = createAction(
  UserActionTypes.UPDATE_CURRENT_TENANT_INFO,
  props<{ tenantInfo: any }>(),
);
